module.exports = __webpack_public_path__ + "front/img/logo-login.7951b40d.png";